// extracted by mini-css-extract-plugin
export var circle = "_bn-1";
export var exitConfirmationModal = "_bn-5";
export var iframe = "_bn-0";
export var offline = "_bn-3";
export var online = "_bn-2";
export var workstationSelectError = "_bn-4";